import { Button, FileInput } from "@mantine/core";
import { FileArrowUp as IconFileUpload } from "@phosphor-icons/react";
import { useState } from "react";

interface XmlImportProps {
  doImport: (content: string) => void;
  disabled?: boolean;
}

export default function XmlImport({ doImport, disabled = false }: XmlImportProps) {
  const [file, setFile] = useState<File | null>(null);

  const handleUpload = async () => {
    if (!file) {
      return;
    }

    const text = await file.text();
    doImport(text);
    setFile(null);
  };

  return (
    <div>
      <FileInput
        label="Read Prospecting XML"
        placeholder="Choose an XML file"
        value={file}
        onChange={setFile}
        accept=".xml,text/xml"
        disabled={disabled}
      />
      <Button
        mt="sm"
        leftSection={<IconFileUpload size={16} />}
        disabled={disabled || !file}
        onClick={handleUpload}
      >
        Import XML
      </Button>
    </div>
  );
}
